import React, { useState } from 'react';
import { TextField, Button, Grid, Typography, Box, CircularProgress } from '@mui/material';

import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import Header from '../../components/header';
import Alerts from '../../components/alert';

export default function EditStudent() {
    const [studentData, setStudentData] = useState(null);
    const [rollNo, setRollNo] = useState('');
    const [studentId, setStudentId] = useState(null);  // Store the actual student ID from Firebase
    const [loading, setLoading] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const handleRollNoChange = (e) => {
        setRollNo(e.target.value);
    };

    const fetchStudentData = () => {
        setLoading(true);
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) {
            setLoading(false);
            return;
        }
        
        const q = query(
            collection(db, 'institutions', loggedUser.institution_id, 'students'),
            where('roll_number', '==', rollNo)
        );

        getDocs(q).then(snapshot => {
            if (snapshot.docs.length > 0) {
                setStudentId(snapshot.docs[0].id);  // Store the actual Firebase ID
                setStudentData(snapshot.docs[0].data());
            } else {
                setStudentId(null);
                setStudentData(null);
                setAlertMessage("Student not found");
                setAlertVisible(true);
            }
            setLoading(false);
        }).catch(error => {
            console.error("Error fetching student:", error);
            setLoading(false);
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStudentData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleUpdateStudent = async (e) => {
        e.preventDefault();
        if (!studentId) {
            setAlertMessage("Invalid student. Please fetch student data first.");
            setAlertVisible(true);
            return;
        }

        setLoading(true);
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) {
            setLoading(false);
            return;
        }
        
        const studentRef = doc(db, 'institutions', loggedUser.institution_id, 'students', studentId);

        try {
            await updateDoc(studentRef, studentData);
            setAlertMessage('Student details updated successfully!');
            setAlertVisible(true);
        } catch (error) {
            console.error("Error updating student:", error);
            setAlertMessage('Error updating student!');
            setAlertVisible(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Edit Student" />
            <Box component="section" sx={{ p: 5 }}>
                {alertVisible && <Alerts message={alertMessage} />}
                {loading && <CircularProgress sx={{ display: 'block', margin: '10px auto' }} />}
                <Typography variant="h5" gutterBottom>
                    Enter Roll No. to Edit Student
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            fullWidth
                            label="Roll No."
                            value={rollNo}
                            onChange={handleRollNoChange}
                            variant="outlined"
                            placeholder="e.g., CE-002"
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Button onClick={fetchStudentData} variant="contained" color="primary" fullWidth>
                            Fetch Student
                        </Button>
                    </Grid>
                </Grid>
                {studentData && (
                    <form onSubmit={handleUpdateStudent}>
                        <Grid container spacing={2} sx={{ mt: 3 }}>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Name" name="name" value={studentData.name || ''} onChange={handleChange} variant="outlined" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Email" name="email" value={studentData.email || ''} onChange={handleChange} variant="outlined" type="email" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Phone No." name="phone" value={studentData.phone || ''} onChange={handleChange} variant="outlined" type="tel" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Class" name="class" value={studentData.class || ''} onChange={handleChange} variant="outlined" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Father's Name" name="father_name" value={studentData.father_name || ''} onChange={handleChange} variant="outlined" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Roll Number" name="roll_number" value={studentData.roll_number || ''} onChange={handleChange} variant="outlined" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Date of Birth" name="date_of_birth" value={studentData.date_of_birth || ''} onChange={handleChange} variant="outlined" type="date" InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Admission Number" name="admission_number" value={studentData.admission_number || ''} onChange={handleChange} variant="outlined" />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Button type="submit" variant="contained" color="primary" disabled={loading} fullWidth>
                                    Update Student
                                </Button>
                            </Grid>
                        </Grid>

                    </form>
                )}
            </Box>
        </Layout>
    );
}
